import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-370a7177"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'cell-wrap',
  emits: ['click'],
  setup(__props, { emit: emits }) {



function clickHandle() {
  emits('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "cell-wrap",
    onClick: clickHandle
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _hoisted_1
  ]))
}
}

})